export const normalizeKeyword = (keyword: string) =>
  keyword.trim().replace(/\s+/g, " ");

export const sortKeywords = (keywords: string[]) =>
  [...keywords].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );

export const sanitizeSavedKeywords = (keywords: unknown): string[] => {
  if (!Array.isArray(keywords)) return [];
  return sortKeywords(
    keywords
      .filter((value): value is string => typeof value === "string")
      .map(normalizeKeyword)
      .filter(Boolean)
      .filter(
        (value, index, array) =>
          array.findIndex((item) => item.toLowerCase() === value.toLowerCase()) ===
          index
      )
  );
};

export const addSavedKeyword = (keywords: string[], keyword: string): string[] => {
  const normalized = normalizeKeyword(keyword);
  if (!normalized) return sanitizeSavedKeywords(keywords);
  const existing = sanitizeSavedKeywords(keywords);
  if (existing.some((item) => item.toLowerCase() === normalized.toLowerCase())) {
    return existing;
  }
  return sortKeywords([normalized, ...existing]);
};

export const deleteSavedKeyword = (keywords: string[], keyword: string): string[] => {
  const normalized = normalizeKeyword(keyword).toLowerCase();
  return sanitizeSavedKeywords(keywords).filter(
    (item) => item.toLowerCase() !== normalized
  );
};

export const isKeywordSaved = (keyword: string, savedKeywords: string[]) => {
  const normalized = normalizeKeyword(keyword).toLowerCase();
  if (!normalized) return false;
  return savedKeywords.some((item) => item.toLowerCase() === normalized);
};
